var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"d-flex transparent",class:{'is-ecarewave': _vm.isEcarewave}},[_c('v-main',[_c('v-container',{attrs:{"fill-height":"","fluid":"","ma-0":"","pa-0":""}},[_c('router-view'),_c('alerts')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }